'use client'

import type { Cruz } from '@cruz-com/lookup'
import { asyncSleep } from 'modern-async'
import io, { type Socket } from 'socket.io-client'
import { getAccessToken } from '@/api/util'

let socket: Socket | undefined

async function init(user: Cruz.User, pathname: string | null) {
  if (socket) {
    socket.disconnect()
  }

  const accessToken = await getAccessToken()
  socket = io(`${process.env.NEXT_PUBLIC_SOCKET_URL}/admin`, {
    auth: {
      token: accessToken,
      email: user?.email,
      pathname,
    },
  })
}

async function reconnect() {
  if (socket) {
    socket.disconnect()
    await asyncSleep(10)
    socket.connect()
  }
}

async function disconnect() {
  if (socket) {
    socket.disconnect()
  }
}

export const cruzSocket = {
  get socket() {
    return socket as Socket
  },
  init,
  reconnect,
  disconnect,
}
